import axios from '@axios'

export const state = {
  templates: [],
  template: {},
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allTemplates: (state) => state.templates,
  templateAndReplies: (state) => state.template,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPage: (state) => state.totalPage,
  totalRecord: (state) => state.totalRecord,
}

export const mutations = {
  CLEAR_TEMPLATE_STATE: (state) => {
    state.templates = []
    state.currentPage = 1
    state.perPage = 15
    state.totalPage = 1
    state.totalRecord = 0
  },
  CLEAR_TEMPLATE_REPLY_STATE: (state) => {
    state.template = {}
  },
  GET_TEMPLATES: (state, resp) => {
    if (!resp) return null
    state.templates = resp.templates
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPage = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  GET_TEMPLATE: (state, resp) => {
    if (!resp) return null
    state.template = resp
  },
  CREATE_REPLY: (state, resp) => {
    if (!resp) return null
    state.template.replies.unshift(resp)
  },
  CREATE_TEMPLATE: (state, resp) => {
    if (!resp) return null
    state.templates.unshift(resp)
  },
  UPDATE_TEMPLATE: (state, resp) => {
    if (!resp) return null
    const idx = state.templates.findIndex((t) => t.id === resp.id)
    if (idx !== -1) {
      state.templates.splice(idx, 1, resp)
    }
  },
  REMOVE_REPLY: (state, template) => {
    if (!template) return null
    state.template.replies = state.template.replies.filter(
      (item) => item.id !== template.id
    )
  },
  REMOVE_TEMPLATE: (state, id) => {
    state.templates = state.templates.filter((t) => t.id !== id)
  },
}

export const actions = {
  async getTemplates({ commit }) {
    commit('CLEAR_TEMPLATE_STATE')
    await axios
      .get(`/api/templates`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('CLEAR_TEMPLATE_STATE')
          let data = Object.assign({}, resp.data)
          commit('GET_TEMPLATES', data)
        }
      })
      .catch(() => {
        commit('GET_TEMPLATES', null)
      })
  },
  async getTemplateById({ commit }, templateId) {
    commit('CLEAR_TEMPLATE_REPLY_STATE')
    await axios
      .get(`/api/templates/${templateId}/replies`)
      .then((resp) => {
        if (resp.status === 200) {
          let data = Object.assign({}, resp.data)
          commit('GET_TEMPLATE', data)
        }
      })
      .catch(() => {
        commit('GET_TEMPLATE', null)
      })
  },
  async createTemplate({ commit }, payload) {
    await axios
      .post(`/api/templates`, payload)
      .then((resp) => {
        if (resp.status === 201) {
          let data = Object.assign({}, resp.data)
          commit('CREATE_TEMPLATE', data)
        }
      })
      .catch(() => {
        commit('CREATE_TEMPLATE', null)
      })
  },
  async updateTemplate({ commit }, payload) {
    await axios
      .put('/api/templates', payload)
      .then((resp) => {
        if (resp.status === 200) {
          let data = Object.assign({}, resp.data)
          commit('UPDATE_TEMPLATE', data)
        }
      })
      .catch(() => {
        commit('UPDATE_TEMPLATE', null)
      })
  },
  async deleteTemplate({ commit }, id) {
    await axios
      .delete(`/api/templates/${id}`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('REMOVE_TEMPLATE', id)
        }
      })
      .catch(() => {
        // Optionally handle error
      })
  },
}
